import { useQuery } from 'react-query';
import { getNutrientDv } from '../api/getNutrientDv';

const useNutrientDv = (shareToken) => {
  const result = useQuery('nutrient_dv_' + shareToken, () => getNutrientDv(shareToken), {
    enabled: !!shareToken,
    refetchOnWindowFocus: false,
    staleTime: 3600,
  });
  return result;
};

export default useNutrientDv;
